import React from 'react';
import { ThemedText } from '../../../components';

/**
 * SubformListValue — placeholder component for repeated form child submissions.
 * The actual rendering of child submissions requires access to childSubmissions
 * data, schema, and recursive rendering logic. This component delegates to
 * a `renderChildren` callback provided in options, allowing the parent page
 * to supply its existing child-rendering logic during migration.
 */
export default function SubformListValue({ value, field, emptyValue = '—', theme, renderChildren }) {
  if (typeof renderChildren === 'function') {
    return renderChildren(value, field);
  }

  const count = Array.isArray(value) ? value.length : 0;
  if (count === 0) {
    return <ThemedText style={{ color: theme?.colors?.muted }}>{emptyValue}</ThemedText>;
  }

  return <ThemedText>{count} submission{count !== 1 ? 's' : ''}</ThemedText>;
}
